import { HomeRepairService } from '@mui/icons-material';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BoltIcon from '@mui/icons-material/Bolt';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import CopyrightIcon from '@mui/icons-material/Copyright';
import MapIcon from '@mui/icons-material/Map';
import MenuIcon from '@mui/icons-material/Menu';
import PetsIcon from '@mui/icons-material/Pets';
import SchoolIcon from '@mui/icons-material/School';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import { useTheme } from "@mui/material/styles";
import React, { ReactNode } from "react";
import { T } from "../_/text/text";
import { MutableState } from "../_/utils/MutableState";
import MenuListItem from "./MenuListItem";
import BackpackIcon from '@mui/icons-material/Backpack';

type Props = {
    openMenu: MutableState<boolean>;
}

function Menu({ openMenu }: Props) {
    const theme = useTheme();
    const [openCollapse, setOpenCollapse] = React.useState(false);
    function handleOpenSettings() {
        setOpenCollapse(!openCollapse);
    }

    return (
        <div style={{ backgroundColor: theme.palette.background.default }}>
            <Drawer open={openMenu.status} onClose={openMenu.setState(false)}>
                <Box role="presentation" >
                    <List disablePadding onClick={openMenu.setState(false)}>
                        {menu.map(MenuItem.render)}
                    </List>
                    <Divider />
                    <List onClick={openMenu.setState(false)}>
                        {menu2.map(MenuItem.render)}
                    </List>
                    {/* <List disablePadding>
                        <ListItem button onClick={handleOpenSettings}>
                                <ListItemIcon>
                                    <MenuIcon/>
                                </ListItemIcon>
                                <ListItemText primary={"Expand"} />
                            {openCollapse ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                            <List sx={{marginLeft:2}} component="div" disablePadding onClick={openMenu.setState(false)}>
                                {[{ text: 'Stwórz postać', icon: <MenuIcon />, link: '/create-character' }].map(MenuItem.render)}
                            </List>
                        </Collapse>
                    </List>
                    <Divider />
                    <List>
                        {[{ text: 'Stwórz postać', icon: <MenuIcon />, link: '/create-character' }].map(MenuItem.render)}
                    </List> */}
                </Box>
            </Drawer>
        </div>
    );
}

export { Menu };


class MenuItem {
    constructor(
        public text: string,
        public icon: ReactNode,
        public link: string,
    ) { }

    static render = (item: MenuItem) => (
        <MenuListItem
            text={item.text}
            icon={item.icon}
            link={item.link}
            key={item.link}
        />
    )
}

const menu: Array<MenuItem> = [
    { text: T.menu.focus, icon: <CopyrightIcon />, link: '/focus' },
    { text: T.menu.character, icon: <AccessibilityIcon />, link: '/character' },
    { text: T.menu.mechanics, icon: <HomeRepairService />, link: '/rules' },
    { text: T.menu.combat, icon: <BoltIcon />, link: '/fight' },
    { text: T.menu.fall, icon: <SentimentVeryDissatisfiedIcon />, link: '/fall' },
    // { text: T.menu.travel, icon: <MapIcon />, link: '/travel' },
    { text: T.menu.backpack, icon: <BackpackIcon />, link: '/backpack' },
    { text: T.menu.skills, icon: <SchoolIcon />, link: '/skills' },
    { text: T.menu.bestiary, icon: <PetsIcon />, link: '/bestiary' },
]

const menu2 = [
    { text: 'Stwórz postać', icon: <MenuIcon />, link: '/create-character' },
    { text: T.menu.contact, icon: <ContactPageIcon />, link: '/contact' },
]